import {useState, useEffect} from 'react'

const Codigos = (props) => {
    const [nombre, setNombre] = useState('')
    const [clave, setClave] = useState('')
    const [usuario, setUsuario] = useState('')
    const [email, setEmail] = useState('')
    const [usuarios, setUsuarios] = useState([])
    const [recargar, setRecargar] = useState(0)
    const [elegido, setElegido] = useState({})
    const [modo, setModo] = useState('Agregar')
    const [permisos, setPermisos] = useState(0)
    const [cambiarClave, setCambiarClave] = useState(false)
    const [mostrarClave, setMostrarClave] = useState(false)
    const f_selected = 'grid grid-cols-4 gap-2 justify-self-start text-sm bg-white text-red-600 w-full'
    const f_no = 'grid grid-cols-4 gap-2 justify-self-start text-sm bg-white w-full'
    const tachado = 'col-span-2 justify-self-start px-2 line-through'
    const notachado = 'col-span-2 justify-self-start px-2'

    const permiso = [
        {valor: 1, cartel: 'Descargar'},
        {valor: 2, cartel: 'Guardar Cambios'},
        {valor: 4, cartel: 'Eliminar'},
        {valor: 8, cartel: 'Ver adjuntos'},
        {valor: 16, cartel: 'Ver QR'},
        {valor: 32, cartel: 'Enviar Invitación'},
        {valor: 64, cartel: 'Enviar QR'}
    ]

    const permitir = (e, cual) => {
        console.log(e)
        console.log(cual)
        setPermisos(e ? permisos + cual : permisos - cual)
    }

    const guardar = () => {
        if(!usuario) {
            alert('Hace falta un nombre para el usuario')
            return
        }
        const existe = usuarios.find (a => a.id === usuario)
        if (existe !== undefined) {
            alert('Ya existe un usuario con ese nombre de usuario')
            return
        }
         if (cambiarClave) {
            actualizarClave()
        }
        var data = {
            user: usuario, 
            evento: props.evento.id,
            id: elegido.id || 0,
            email: email,
            nombre: nombre,
            permisos: permisos
        }
                
        const subir = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify(data)
        }
        fetch(props.back + 'admin/guardar_usuario', subir)
        .then (response => response.json())
        .then (json => {
            setNombre('')
            setUsuario('')
            setEmail('')
            setClave('')
            setRecargar(recargar + 1)
            setPermisos(0)
            setElegido({id:0})
        })
    }

    const eliminar = () => {
        const data = {
            method: 'POST',
            body: JSON.stringify({id: elegido.id}),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/eliminar_usuario', data)
        .then (response => response.json())
        .then (json => {
            setNombre('')
            setUsuario('')
            setEmail('')
            setClave('')
            setRecargar(recargar + 1)
            setElegido({id:0})
        })
    }

    const bloquear = () => {
        const data = {
            method: 'POST',
            body: JSON.stringify({id: elegido.id}),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/bloquear_usuario', data)
        .then (response => response.json())
        .then (json => {
            setNombre('')
            setUsuario('')
            setEmail('')
            setClave('')
            setRecargar(recargar + 1)
            setElegido({id:0})
        })
    }
    const actualizarClave = () => {
        const data = {
            method: 'POST',
            body: JSON.stringify({id: elegido.id, pass: clave}),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/cambiar_clave', data)
        .then (response => response.json())
        .then (json => {
            setNombre('')
            setUsuario('')
            setEmail('')
            setClave('')
            setRecargar(recargar + 1)
            setElegido({id:0})
            setCambiarClave(false)
        })
    }

    const mostrar = () => {
        return usuarios.map(a => {
            return (
                <div className={a.id===elegido.id ? f_selected : f_no} onClick={e => elegir(a)}>
                    <label className={a.bloqueado ? tachado : notachado}>{a.nombre}</label>
                    <label className='justify-self-start px-2'>{a.email}</label>
                    <label className='justify-self-start px-2'>{a.user}</label>
                </div>
            )
        })        
    }

     const elegir = (a) => {
       setElegido(a.id === elegido.id ? {id: 0} : a )
       setNombre(a.id === elegido.id ? '' : a.nombre)
       setEmail(a.id === elegido.id ? '' : a.email)
       setUsuario(a.id === elegido.id ? '' : a.user)
       setClave('')
       setCambiarClave(false)
       setModo(a.id === elegido.id ? 'Agregar' : 'Editar')
       setPermisos(a.id === elegido.id ? 0 : a.permisos)
    }

    useEffect(() => {
        const data = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        }
        fetch(props.back + 'admin/traer_usuarios/' + props.evento.id, data)
        .then (response => response.json())
        .then (json => setUsuarios(json))
    },[props.evento, recargar, props.back, props.token])

    return (<>
    <div className='grid grid-cols-2 my-2 text-sm w-full'>
        <div className='flex px-2 flex-col justify-start w-full overflow-x-hidden'>
            <div className='grid grid-cols-4 gap-2 border-b-2 border-2 border-zinc-800 items-center text-sm'>
                <label className='col-span-2 justify-self-start px-2'>Nombre</label>
                <label className='justify-self-start px-2'>Email</label>
                <label className='justify-self-start px-2'>Usuario</label>
            </div>
            <div className='overflow-y-auto overflow-x-hidden h-9/10 w-full text-sm'>
                {mostrar()}
            </div>
        </div>
        <div className='bg-gray-300 flex flex-col justify-start px-2 w-1/2'>
            <div className='grid grid-cols-2 gap-2 my-2'>
                <label className='w-64 my-2 px-2 text-red-600'>{modo}</label>
                <button 
                    className='bg-white text-blue-800 p-2 hover:text-white hover:bg-blue-800'
                    onClick={e => guardar()}
                >
                    Guardar
                </button>
            </div>
            <div className='grid grid-cols-2 gap-2 my-2'>
            <label className='px-2 justify-self-start'>Nombre</label>
            <input 
                type='text'
                className='px-2 w-48 bg-white outline-0'
                value={nombre}
                onChange={e => setNombre(e.target.value)}
            />
        </div>
        <div className='grid grid-cols-2 gap-4 my-2'>
            <label className='px-2 justify-self-start'>Email</label>
            <input 
                type='text'
                className='px-2 w-48 bg-white outline-0'
                value={email}
                onChange={e => setEmail(e.target.value)}
            />
        </div>
        <div className='grid grid-cols-2 gap-4 my-2'>
            <label className='px-2 justify-self-start'>Usuario</label>
            <input 
                type='text'
                className='px-2 w-48 bg-white outline-0'
                value={usuario}
                onChange={e => setUsuario(e.target.value)}
            />
        </div>
        {cambiarClave ?
            <div className='grid grid-cols-2 gap-4 my-2'>
                <label className='px-2 justify-self-start'>Clave</label>
                <div className='flex flex-row'>
                <input 
                    type={mostrarClave ? 'text' : 'password'}
                    className='px-2 w-48 bg-white outline-0 mr-3'
                    value={clave}
                    onChange={e => setClave(e.target.value)}
                />
                <label onClick={e => setMostrarClave(! mostrarClave)}>{mostrarClave ? '👁️‍🗨️' : '👁️'}</label>
                </div>
            </div>
        : '' }
        <div className='grid grid-cols-2 my-2 w-full'>
            <div className='flex items-center justify-start px-2'>
                Permisos
            </div>
            <div className='flex flex-col w-full'>
                {permiso.map(a => {
                    return (
                        <div className='flex flex-row items-center pox-2'>
                            <input 
                                type='checkbox'
                                className='w-3'
                                value={a.valor}
                                checked={permisos & a.valor}
                                onChange={e => permitir(e.target.checked, a.valor)}
                            />
                            <label className='text-sm ml-5'>{a.cartel}</label>
                        </div>
                    )
               })}
           </div>
        </div>
            <div className='col[-span-2 flex flex-row w-full justify-between mt-2'>
                <button 
                    className='text-sm w-20 p-2 text-white bg-red-400 hover:bg-red-800 rounded-xl disabled:bg-zinc-500'
                    disabled={!elegido.id}
                    onClick= { e => eliminar()}
                >
                    Eliminar
                </button>
                <button 
                    className='text-sm w-32 p-2 mx-2 text-white bg-red-400 hover:bg-red-800 rounded-xl disabled:bg-zinc-500'
                    disabled={!elegido.id}
                    onClick= { e => setCambiarClave(true)}
                >
                    Cambiar Clave
                </button>
                <button 
                    className='text-sm w-24 p-2 text-white bg-red-400 hover:bg-red-800 rounded-xl disabled:bg-zinc-500'
                    disabled={!elegido.id}
                    onClick= { e => bloquear()}
                >
                    {elegido.id && elegido.bloqueado ? 'Desbloquear' : 'Bloquear'}
                </button>
            </div>
        </div>
    </div>
    </>)
}

export default Codigos
